import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-restart",
  "use": "icon-restart-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-restart\"><path d=\"M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm4.2 14.2C13.1 15.4 11.6 16 10 16s-3.1-.6-4.3-1.8C4.6 13.1 4 11.6 4 10s.7-3.2 1.9-4.4l1.4 1.5C6.5 7.8 6 8.9 6 10c0 1.1.4 2.1 1.2 2.8.7.8 1.7 1.2 2.8 1.2s2.1-.4 2.8-1.2C13.6 12 14 11 14 10s-.4-2.1-1.2-2.8c-.5-.5-1.2-.9-1.8-1V8L8 5l3-3v2.1c1.2.2 2.3.8 3.2 1.7C15.4 6.9 16 8.4 16 10s-.6 3.1-1.8 4.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol